import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import classnames from 'classnames';
import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';

import './rating-stars-input.scss';

const STARS = [5, 4, 3, 2, 1];

export class RatingStarsInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue ? props.defaultValue.toString() : undefined,
    };
  }

  setValue = event => {
    const { onChange } = this.props;
    const {
      target: { value },
    } = event;

    this.setState({ value }, () => {
      onChange(event);
    });
  };

  // Used for validation
  // eslint-disable-next-line no-restricted-syntax
  get value() {
    return this.state.value;
  }

  render() {
    const { name, defaultValue, starClassName, onBlur } = this.props;

    return (
      <div className="stars-radio-list d-flex flex-row-reverse justify-content-end">
        {STARS.map(value => {
          const inputId = `radio-${name}-${value}`;
          return (
            <Fragment key={inputId}>
              <Input
                className="radio-input m-0"
                type="radio"
                value={value}
                name={name}
                id={inputId}
                aria-label={value === 1 ? '1 star' : `${value} stars`}
                onChange={this.setValue}
                onBlur={onBlur}
                defaultChecked={value === defaultValue}
              />
              <Label className={classnames('icon-label-star', starClassName)} for={inputId} />
            </Fragment>
          );
        })}
      </div>
    );
  }
}

RatingStarsInput.propTypes = {
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  starClassName: PropTypes.string,
  defaultValue: PropTypes.number,
};

RatingStarsInput.defaultProps = {
  onChange: noop,
  onBlur: null,
  starClassName: 'mb-0',
  defaultValue: null,
};
